
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
/* eslint-disable prettier/prettier */
import { Head } from "@/components/Head";
import { Converter } from "@/containers/Converter";
import { useTheme } from "@/hooks/useTheme";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { CTASection } from "@/sections/CTASection";
import { MagicianSection } from "@/sections/MagicianSection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import Trans from "next-translate/Trans";
import useTranslation from "next-translate/useTranslation";
import React from "react";

const LucidchartToFigjam = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/LucidChartToFigjam"
        ogImage="/images/lucidchart2figjam-og-image.png"
      />

      <MagicianSection
        title={t("page/LucidChartToFigjam:title")}
        subtitle={t("page/LucidChartToFigjam:subtitle")}
        magicianLogoFile="lucidchart"
        showStartsAt={false}
      >
        <Converter disabled />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/LucidChartToFigjam:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        backgroundColor="#fffffe"
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t(
          "page/LucidChartToFigjam:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
        image={{
          src: "/images/lucidchart-to-figjam-example.png",
          alt: "LucidChart to Figma Example",
        }}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/LucidChartToFigjam:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/lucidchart-to-figjam-converted-file-elements.jpg",
          alt: t("page/LucidChartToFigjam:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/LucidChartToFigjam:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "NOTES",
            title: t(
              "page/LucidChartToFigjam:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/LucidChartToFigjam:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "CHECK-ICON-EMPTY",
            title: t(
              "page/LucidChartToFigjam:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/LucidChartToFigjam:section/shareDesign.elements.folderStructureText",
            ),
          },
        ]}
      />

      <ConversionSection
        title={t("page/LucidChartToFigjam:section/conversion.title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t(
              "page/LucidChartToFigjam:section/conversion.badges.supportsAll",
            ),
          },
          {
            iconType: "NOTES",
            text: t(
              "page/LucidChartToFigjam:section/conversion.badges.stickyNotes",
            ),
          },
          {
            iconType: "ARROW-BLACK",
            text: t(
              "page/LucidChartToFigjam:section/conversion.badges.connectors",
            ),
          },
        ]}
        elements={{
          from: {
            iconType: "LUCIDCHART",
            image: "/images/lucidchart-figjam-preview.jpg",
            title: "LucidChart Demo Preview",
          },
          to: {
            iconType: "FIGJAM",
            image: "/images/lucidchart-figjam-preview.jpg",
            title: "Figjam Demo Preview",
          },
        }}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.lucidchartToFigjamPage")}
        href="#upload"
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default LucidchartToFigjam;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/lucidchart-to-figjam',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  